import _ from 'lodash';
import CONSTANTS from '../constants';
import GoogleHelper from '../helpers/GoogleHelper';
import OrderTypeHelper from '../helpers/OrderTypeHelper';
import PromotionsHelper from '../helpers/PromotionsHelper';
import ViewHelper from '../helpers/ViewHelper';

export default {
  addItem,
  removeItem,
  removeItemWithOptions,
  remove,
  addOptions,
  setCart,
  setDeliveryCharge,
  getDeliveryCharge,
  removeDeliveryCharge,
  getCart,
  getQuantityFor,
  getCount,
  getTotal,
  getOrderTotal,
  getOrderSubTotalWithAllCharges,
  getOrderTotalWithAllCharges,
  getTax,
  getTaxWithDelivery,
  getTotalFor,
  getTotalAfterDiscountFor,
  getLineItems,
  getGroupedOptions,
  getUniqueIdentifierFor,
  transformedCart,
  setCreatedOrder,
  getCreatedOrder,
  removeCreatedOrder,
  setOrderData,
  getOrderData,
  getDiscount,
  clearOrderData,
  getPromoForCart,
  getInitialStateFor,
  getMinDistanceLocation,
  getOrderTotalWithTax,
  getTaxWithTotal,
  setLoyaltyDiscount,
  getLoyaltyDiscount,
  getBinDiscount,
  setBinForCart,
  getBinForCart,
  checkDiscount,
  deleteDiscountsFromCart,
  deleteBinDiscountsFromCart
};
function addItem(item, quantity = 1) {
  let cart = this.getCart();
  let updatedCart = cart ? _.clone(cart, true) : [];
  for (let i = 0; i < quantity; i++) updatedCart.push({ ...item });
  this.setCart(updatedCart);
}

function removeItemWithOptions(item) {
  let cart = this.getCart();
  let alreadyInCart = _.findLastIndex(
    cart,
    (cartItem) => this.getUniqueIdentifierFor(cartItem) === this.getUniqueIdentifierFor(item)
  );
  this.remove(cart, alreadyInCart);
}

function removeItem(item) {
  let cart = this.getCart();
  let alreadyInCart = _.findLastIndex(cart, (cartItem) => cartItem.menu_id === item.menu_id);
  this.remove(cart, alreadyInCart);
}

function remove(cart, alreadyInCart) {
  if (alreadyInCart > -1) {
    let updatedCart = cart ? _.clone(cart, true) : [];
    _.pullAt(updatedCart, [alreadyInCart]);
    this.setCart(updatedCart);
  }
}

function addOptions(item, options, comment = '', quantity = 1) {
  this.removeItem(item);
  item.options = options;
  item.comment = comment;
  this.addItem(item, quantity);
}

function getQuantityFor(item, loc_id) {
  return _.filter(
    this.getCart(),
    (cartItem) =>
      parseInt(cartItem.menu_id, 10) === parseInt(item.menu_id, 10) &&
      parseInt(cartItem.loc_id) === parseInt(loc_id) && cartItem.isRewardItem === undefined
  ).length;
}

function getCount(locationId) {
  return this.getCart(locationId).length;
}

function getTotal(locationId) {
  return _.sumBy(this.getCart(locationId), (item) => {
    return this.getTotalFor(item);
  });
}

function getDiscount(
  location,
  promotions = null,
  orderType = null,
  fixedPromo = null,
  isOutlet = false
) {
  console.log("🚀 getDiscount called with:", { location, promotions, orderType, fixedPromo, isOutlet });

  if (orderType) {
    orderType = parseInt(orderType);
    console.log("🔢 Parsed orderType:", orderType);
  }

  const items = this.getCart(location.loc_id);
  console.log("🛒 Cart items:", items);
  console.log("All promotions : ", promotions)

  let promoIds = PromotionsHelper.getAllApplicablePromoIdsFor(items);
  console.log("🏷️ Applicable promo IDs:", promoIds);

  let originalSum = this.getTotal(location.loc_id);
  console.log("💰 Original cart total:", originalSum);

  let minSum = originalSum;
  let promoId = null;
  let promoCode = null;

  console.log("🔍 Starting evaluation of item-based and category-based promotions...");

  for (let i = 0; i < promoIds.length; i++) {
    console.log(`➡️ Checking promo ID: ${promoIds[i]}`);

    if (fixedPromo) {
      console.log("📌 Fixed promo specified:", fixedPromo);
      if (promoIds[i] !== fixedPromo.toString()) {
        console.log(`⏭️ Skipping promo ID ${promoIds[i]} as it doesn't match fixedPromo`);
        continue;
      }
    }

    if (orderType) {
      const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
      console.log("📦 Matching order type from location:", orderTypeloc);

      const orderTypeObjects = PromotionsHelper.getOrderTypesByPromoId(promoIds[i], promotions);
      const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
      console.log("✅ Active order type IDs for promo:", orderTypeIds);

      if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
        console.log("❌ Promo doesn't support this order type, skipping.");
        continue;
      }
    }

    let currentSum = 0;
    let currentDis = 0;

    const maxDis = PromotionsHelper.getMaxDisFor(promoIds[i], promotions);
    console.log(`🎯 Max discount allowed for promo ${promoIds[i]}:`, maxDis);

    for (let j = 0; j < items.length; j++) {
      const originalPrice = this.getTotalFor(items[j]);
      let discountedPrice = originalPrice;

      console.log(`🧾 Item ${j} original price:`, originalPrice);

      if (items[j].discounts && items[j].discounts[promoIds[i]]) {
        discountedPrice = PromotionsHelper.getDiscountedPriceFor(
          originalPrice,
          items[j].discounts[promoIds[i]]
        );
        console.log(`✅ Discounted price using promo ${promoIds[i]}:`, discountedPrice);
      }

      if (discountedPrice < 0) discountedPrice = 0;

      currentSum += discountedPrice;
      currentDis += originalPrice - discountedPrice;
    }

    console.log(`📉 Total discount for promo ${promoIds[i]}:`, currentDis);
    console.log(`🧮 Current total after discount:`, currentSum);

    if (currentDis > maxDis && maxDis !== 0) {
      console.log("⚠️ Discount exceeded max limit, capping it.");
      currentSum = originalSum - maxDis;
    }

    if (currentSum < minSum) {
      console.log("✅ Found better promo! Updating minSum and promoId");
      minSum = currentSum;
      promoId = promoIds[i];
    }
  }

  // Basket promotions
  if (promotions) {
    console.log("🧺 Checking basket-level promotions...");

    const basketPromos = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];

    for (let i = 0; i < basketPromos.length; i++) {
      const prom = basketPromos[i];
      console.log("➡️ Evaluating basket promo:", prom);

      if (fixedPromo) {
        console.log("📌 Fixed promo specified:", fixedPromo);
        if (prom.id.toString() !== fixedPromo.toString()) {
          console.log("⏭️ Skipping non-matching basket promo");
          continue;
        }
      }

      if (orderType) {
        const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
        const orderTypeObjects = PromotionsHelper.getOrderTypesByPromoId(prom.id, promotions);
        const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);

        console.log("✅ Basket promo allowed order types:", orderTypeIds);

        if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
          console.log("❌ Basket promo doesn't apply to this order type, skipping.");
          continue;
        }
      }

      const dis = prom.PromotionDiscount;
      const applicableLevel = PromotionsHelper.getApplicableDiscountLevel(
        originalSum,
        dis.PromotionDiscountLevels
      );
      console.log("📊 Applicable basket discount level:", applicableLevel);

      if (!applicableLevel) {
        console.log("⛔ No applicable level found for basket promo, skipping.");
        continue;
      }

      let dis_amount = 0;

      if (
        applicableLevel.reward_type ===
        CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        dis_amount = (applicableLevel.reward / 100) * originalSum;
        console.log(`%️⃣ Percentage reward applied: ${applicableLevel.reward}%, calculated discount: ${dis_amount}`);
      } else {
        dis_amount = applicableLevel.reward;
        console.log(`💵 Fixed reward applied:`, dis_amount);
      }

      if (dis_amount > prom.max_discount_amount && prom.max_discount_amount !== 0) {
        console.log(`⚠️ Discount exceeded max limit of ${prom.max_discount_amount}, capping it.`);
        dis_amount = prom.max_discount_amount;
      }

      const newPrice = originalSum - dis_amount;
      console.log("💸 Final price after basket promo applied:", newPrice);

      if (newPrice < minSum) {
        console.log("✅ Basket promo is better! Updating minSum and promoId.");
        minSum = newPrice;
        promoId = prom.id;
      }
    }
  }
  let promoChanged = false;
  if (promoId !== null) {
    console.log("🏁 Best promo applied to cart:", promoId);
    const prevPromoId = getPromotionForCart();
    console.log("🏁 Previous promo applied to cart:", prevPromoId);
    if (prevPromoId?.toString() !== promoId?.toString()) {
      promoChanged = true;
    }
    setPromoForCart(promoId);
  } else {
    console.log("⚠️ No applicable promo found.");
  }

  const result = { discount: originalSum - minSum, promoId, promoChanged };
  console.log("🎉 Final discount result:", result);
  return result;
}

function getBinDiscount(
  location,
  bindiscounts = null,
  orderType = null,
  fixedPromo = null,
  isOutlet = false
) {
  let error = '';
  let context = 'Whoops!';
  if (orderType) orderType = parseInt(orderType);
  const items = this.getCart(location.loc_id);
  let binIds = PromotionsHelper.getAllApplicableBinFor(items);
  let originalSum = this.getTotal(location.loc_id);
  let minSum = originalSum;
  let promoId = null;
  let isBasketPromo = false;
  for (let i = 0; i < binIds.length; i++) {
    if (fixedPromo) if (binIds[i] !== fixedPromo.toString()) continue;
    if (!isOutlet) {
      if (orderType) {
        const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
        const orderTypeObjects = PromotionsHelper.getBinDiscountOrderTypes(binIds[i], bindiscounts);
        const orderTypeIds = orderTypeObjects.map((o) => o.OrderType.order_type);
        if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
          error = 'The discount is valid for ' + orderTypeObjects.map((o, index) => orderTypeObjects.length - 1 !== index ? ViewHelper.capitalizeFirstLetter(o.OrderType.label) + ', ' : ViewHelper.capitalizeFirstLetter(o.OrderType.label)).join('') + ' orders only.'; continue;
        }
      }
    }

    let currentSum = 0;
    let currentDis = 0;
    const maxDis = PromotionsHelper.getMaxDisBinFor(binIds[i], bindiscounts);
    for (let j = 0; j < items.length; j++) {
      const originalPrice = this.getTotalFor(items[j]);
      let discountedPrice = originalPrice;
      if (items[j].bindiscounts && items[j].bindiscounts[binIds[i]])
        discountedPrice = PromotionsHelper.getDiscountedPriceFor(
          originalPrice,
          items[j].bindiscounts[binIds[i]]
        );
      if (discountedPrice < 0) discountedPrice = 0;
      currentSum += discountedPrice;
      currentDis += originalPrice - discountedPrice;
    }
    if (currentDis > maxDis && maxDis !== 0) {
      currentSum = originalSum - maxDis;
    }

    if (currentSum < minSum) {
      minSum = currentSum;
      promoId = binIds[i];
    }
  }
  if (bindiscounts) {
    const basketPromos = bindiscounts[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];
    for (let i = 0; i < basketPromos.length; i++) {
      if (fixedPromo) if (basketPromos[i].id.toString() !== fixedPromo.toString()) continue;
      const prom = basketPromos[i];
      if (!isOutlet) {
        if (orderType) {
          const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
          const orderTypeIds = prom.BindiscountOrderTypes.map((o) => o.OrderType.order_type);
          if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0) {
            isBasketPromo = true;
            error = 'The discount is valid for ' + prom.BindiscountOrderTypes.map((o, index) => prom.BindiscountOrderTypes.length - 1 !== index ? ViewHelper.capitalizeFirstLetter(o.OrderType.label) + ', ' : ViewHelper.capitalizeFirstLetter(o.OrderType.label)) + ' orders only.';
            continue;
          }
        }
      }
      const dis = prom.BindiscountDiscount;
      const applicableLevel = PromotionsHelper.getApplicableDiscountLevel(
        originalSum,
        dis.BindiscountDiscountLevels
      );
      if (!applicableLevel) {
        const discountLevels = _.sortBy(dis.BindiscountDiscountLevels, "expenditure")
        isBasketPromo = true;
        error = 'The discount is valid on orders above Rs ' + discountLevels[0].expenditure + '.';
        continue;
      }
      if (
        applicableLevel.reward_type ===
        CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.REWARD_TYPE.PERCENTAGE
      ) {
        let dis_amount = (applicableLevel.reward / 100) * originalSum;
        if (dis_amount > prom.max_discount_amount && prom.max_discount_amount !== 0)
          dis_amount = prom.max_discount_amount;
        const newPrice = originalSum - dis_amount;
        if (newPrice < minSum) {
          minSum = newPrice;
          promoId = prom.id;
        }
        isBasketPromo = true;

      } else {
        let dis_amount = applicableLevel.reward;
        if (dis_amount > prom.max_discount_amount && prom.max_discount_amount !== 0)
          dis_amount = prom.max_discount_amount;
        const newPrice = originalSum - dis_amount;
        if (newPrice < minSum) {
          minSum = newPrice;
          promoId = prom.id;
        }
        isBasketPromo = true;

      }
    }

  }
  if (promoId !== null) {
    setBinForCart(promoId);
  }
  return { discount: originalSum - minSum, promoId, error: error, context: context, isBasketPromo };
}

function checkDiscount(
  location,
  promotions = null,
  orderType = null,
  fixedPromo = null,
  isOutlet = false
) {
  if (orderType) orderType = parseInt(orderType);
  const items = this.getCart(location.loc_id);
  let promoIds = PromotionsHelper.getAllApplicablePromoIdsFor(items);
  let originalSum = this.getTotal(location.loc_id);
  let minSum = originalSum;
  let promoId = null;
  let error = null;
  for (let i = 0; i < promoIds.length; i++) {
    if (fixedPromo) if (promoIds[i] !== fixedPromo.toString()) continue;
    if (orderType) {
      const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
      const orderTypeObjects = PromotionsHelper.getOrderTypesByPromoId(promoIds[i], promotions);
      const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
      if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0)
        error = 'Invalid promo code';
      // const orderTypeIds = PromotionsHelper.getPromotionOrderTypes(promoIds[i], promotions);
      // if (orderTypeIds.indexOf(orderType) < 0) continue;
    }

  }
  if (promotions) {
    const basketPromos = promotions[CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.TYPE_STR.BASKET];
    for (let i = 0; i < basketPromos.length; i++) {
      if (fixedPromo) if (basketPromos[i].id.toString() !== fixedPromo.toString()) continue;
      const prom = basketPromos[i];

      if (orderType) {
        const orderTypeloc = _.find(location.orderTypes, (o) => o.id === orderType);
        const orderTypeObjects = PromotionsHelper.getOrderTypesByPromoId(prom.id, promotions);
        const orderTypeIds = orderTypeObjects.filter((o) => o.OrderType.active).map((o) => o.OrderType.order_type);
        if (orderTypeIds.indexOf(orderTypeloc.order_type) < 0)
          error = 'Invalid promo code';

        // const orderTypeIds = prom.PromotionOrderTypes.map((o) => o.order_type_id);
        // if (orderTypeIds.indexOf(orderType) < 0) continue;
      }

    }
  }
  return error;
}

function getTax(locationId, taxPercent) {
  taxPercent = parseFloat(taxPercent) || 0.0;
  return this.getTotal(locationId) * (taxPercent / 100.0);
}

function getTaxWithTotal(total, taxPercent) {
  taxPercent = parseFloat(taxPercent) || 0.0;
  return total * (taxPercent / 100.0);
}

function getTaxWithDelivery(
  locationId,
  taxPercent,
) {
  let deliveryCharges = this.getDeliveryCharge(locationId) !== null ? parseInt(this.getDeliveryCharge(locationId)) : 0;
  let netTotal =
    this.getTotal(locationId) + deliveryCharges
  taxPercent = parseFloat(taxPercent) || 0.0;
  return netTotal * (taxPercent / 100.0);
}

function getOrderTotal(locationId, taxPercent) {
  return this.getTotal(locationId) + this.getTax(locationId, taxPercent);
}

function getOrderTotalWithTax(locationId, taxPercent) {
  return this.getTotal(locationId) + taxPercent;
}

function getOrderSubTotalWithAllCharges(
  location,
  promotions = null,
  orderType = null,
  fixedPromo = null,
) {
  let deliveryCharges = this.getDeliveryCharge(location.loc_id) !== null ? parseInt(this.getDeliveryCharge(location.loc_id)) : 0;
  return (
    this.getTotal(location.loc_id) + deliveryCharges
  );
}

function calTotalWithTax(netTotal, taxPercent) {
  taxPercent = parseFloat(taxPercent) || 0.0;
  return netTotal * (taxPercent / 100.0);
}

function getOrderTotalWithAllCharges(
  location,
  taxPercent,
  promotions = null,
  orderType = null,
  fixedPromo = null,
  isOutlet,
  discount
) {
  //let discount = this.getDiscount(location, promotions, orderType, fixedPromo, isOutlet).discount;
  let deliveryCharges = this.getDeliveryCharge(location.loc_id) !== null ? parseInt(this.getDeliveryCharge(location.loc_id)) : 0;
  let subTotal = this.getTotal(location.loc_id) +
    deliveryCharges;
  let netTotal =
    this.getTotal(location.loc_id) +
    deliveryCharges - discount;

  return netTotal + calTotalWithTax(subTotal, taxPercent);
}

function getTotalFor(item) {
  let optionsSum = 0.0;
  if (item.options) optionsSum = _.sumBy(item.options, (option) => parseFloat(option.price) || 0.0);
  const itemPrice = item.portionSize ? item.portionSize.price : item.menu_price;
  return item.isRewardItem ? 0.0 : parseFloat(itemPrice) + parseFloat(optionsSum);
}

function getTotalAfterDiscountFor(item) {
  let optionsSum = 0.0;
  if (item.options) optionsSum = _.sumBy(item.options, (option) => parseFloat(option.price) || 0.0);
  if (item.discounts) return parseFloat(item.discounts.discountedPrice) + parseFloat(optionsSum);
  const itemPrice = item.portionSize ? item.portionSize.price : item.menu_price;
  return parseFloat(itemPrice) + parseFloat(optionsSum);
}

function getLineItems(locationId) {
  // Same items with same options selected are grouped together
  let groupedItems = _.groupBy(this.getCart(locationId), this.getUniqueIdentifierFor);
  let itemIdentifiers = _.keys(groupedItems);
  let lineItems = [];
  itemIdentifiers.forEach((identifier) => {
    let firstItem = groupedItems[identifier][0];
    let firstItemTotal = this.getTotalFor(firstItem);
    let firstItemTotalAfterDiscount = firstItem.discounts
      ? this.getTotalAfterDiscountFor(firstItem)
      : firstItemTotal;
    let lineItem = {
      ...firstItem,
      groupedOptions: this.getGroupedOptions(firstItem),
      identifier: identifier,
      itemCount: groupedItems[identifier].length
    };
    lineItem.itemTotal = firstItemTotal * lineItem.itemCount;
    lineItem.itemTotalAfterDiscount = firstItemTotalAfterDiscount * lineItem.itemCount;
    lineItems.push(lineItem);
  });
  return lineItems;
}

function getGroupedOptions(item) {
  let options = [];
  if (item.options) {
    let groupedOptions = _.groupBy(item.options, (option) => option.option_value_id);
    let optionIdentifiers = _.keys(groupedOptions);
    optionIdentifiers.forEach((identifier) => {
      let firstOption = groupedOptions[identifier][0];
      let option = {
        ...firstOption,
        identifier: identifier,
        optionCount: groupedOptions[identifier].length
      };
      options.push(option);
    });
  }
  return options;
}

function getUniqueIdentifierFor(item) {
  if (item.options && item.options.length > 0) {
    let sortedOptions = _.sortBy(item.options, (option) => option.option_value_id);
    return `${item.isRewardItem}_${item.comment}_${item.menu_id.toString()}_${item.portionSize?.portion_size_id ? item.portionSize?.portion_size_id.toString() : 'default'}_${sortedOptions
      .map((option) => option.option_value_id)
      .join(',')}`;
  }
  if (!item.comment) item.comment = '';
  return `${item.isRewardItem}_${item.comment}_${item.menu_id.toString()}_${item.portionSize?.portion_size_id ? item.portionSize?.portion_size_id.toString() : 'default'}`;
}

function getCart(locationId = null) {
  let cart = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart`);
  if (!cart) {
    this.setCart([]);
    cart = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart`);
  }
  cart = JSON.parse(cart);
  if (locationId) return _.filter(cart, (item) => item.loc_id === locationId);
  return cart;
}

function setCart(cart) {
  localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart`, JSON.stringify(cart));
}

function setLoyaltyDiscount(data) {
  localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_reward_discount`, data);
}

function getLoyaltyDiscount() {
  let discount = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_reward_discount`);
  if (!discount) {
    this.setLoyaltyDiscount('');
    discount = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_reward_discount`);
  }
  discount = discount ? JSON.parse(discount) : '';
  return discount;
}


function setPromoForCart(promo) {
  localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_promo`, promo);
}

function getPromotionForCart() {
  return localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_promo`);
}


function getPromoForCart() {
  return localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_bin`);
}
function setBinForCart(promo) {
  localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_bin`, promo);
}

function getBinForCart() {
  return localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_bin`);
}
function deleteBinDiscountsFromCart() {
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_bin`);
}
function deleteDiscountsFromCart() {
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_bin`);
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_cart_promo`);
}

function setDeliveryCharge(locationId, amount) {
  localStorage.setItem(
    `${CONSTANTS.CACHE_KEY_PREFIX}_${locationId}_deliveryCharges`,
    JSON.stringify(amount)
  );
}

function getDeliveryCharge(locationId) {
  let charge = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${locationId}_deliveryCharges`);
  if (charge) return JSON.parse(charge);
  return null;
}

function removeDeliveryCharge(locationId) {
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${locationId}_deliveryCharges`);
}

function transformedCart(locationId) {
  return this.getLineItems(locationId).map((item) => {
    const itemPrice = item.portionSize ? item.portionSize.price : item.menu_price;
    let totalPrice = itemPrice * item.itemCount;
    let options = [];
    if (item.groupedOptions && item.groupedOptions.length > 0) {
      options = item.groupedOptions.map((option) => {
        totalPrice += option.price ? option.price * option.optionCount : 0.0;
        option.serverSideOption.Option_Values[0].optionCount = option.optionCount;
        return { ...option.serverSideOption };
      });
    }
    delete item['groupedOptions'];
    return { ...item, MenuOptions: options, total_price: totalPrice };
  });
}

function setCreatedOrder(order) {
  localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_createdOrder`, order ? JSON.stringify(order.orderDB) : '');
}

function getCreatedOrder() {
  let flag = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_createdOrder`);
  if (flag !== "" && flag !== "undefined") { return JSON.parse(flag) } else { return null }
}

function removeCreatedOrder() {
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_createdOrder`);
}

function setOrderData(state, orderTypes, location) {
  const loc_id = location.is_outlet ? location.parent_id : location.loc_id;
  let {
    order_type_id,
    delivery_phone,
    delivery_location,
    delivery_address,
    car_number,
    car_model,
    comment
  } = state;
  let orderType = OrderTypeHelper.getOrderType(orderTypes, order_type_id);
  localStorage.setItem(
    `${CONSTANTS.CACHE_KEY_PREFIX}_${loc_id}_orderData`,
    JSON.stringify({
      // Setting order type instead of order_type_id so that its usable across locations
      order_type: orderType ? orderType.order_type : null,
      order_type_id,
      delivery_phone,
      delivery_location,
      delivery_address,
      car_number,
      car_model,
      comment,
      selectedOutlet: state.selectedOutlet,
      selectedLocation: state.selectedLocation,
      selectedPhone: state.selectedPhone,
      order_time: state.order_time,
      server_time: state.server_time,
      is_res_off: state.is_res_off,
      current_time: state.current_time,
      order_date: state.order_date,
      isPickUpNow: state.isPickUpNow
    })
  );
}

function getMinDistanceLocation(savedUserLocations, geoLocation) {
  let minDistance = 99999;
  let selectedLocation = savedUserLocations[0];
  for (let i = 0; i < savedUserLocations.length; i++) {
    const dis = GoogleHelper.distanceBetweenTwoLatLngStrings(
      geoLocation,
      `${savedUserLocations[i].latitude},${savedUserLocations[i].longitude}`
    );
    if (dis <= minDistance) {
      minDistance = dis;
      selectedLocation = savedUserLocations[i];
    }
  }
  return selectedLocation;
}

function getInitialStateFor(location, outlets, savedUserLocations, geoLocation, prevData) {
  const defaultOutlet = location.is_outlet
    ? outlets.filter((o) => o.loc_id === location.loc_id)[0]
    : null;
  const allowedOrderTypes = OrderTypeHelper.getAllowedOrderTypes(
    defaultOutlet ? [defaultOutlet] : outlets
  );
  if (!allowedOrderTypes) return null;
  let selectedOrderType = null;
  let selectedLocation = null;
  let selectedOutlet = null;
  let deliveryLocation = geoLocation;
  if (savedUserLocations && savedUserLocations.length > 0) {
    if (prevData)
      selectedLocation = savedUserLocations.find(
        (saved_location) =>
          `${saved_location.latitude},${saved_location.longitude}` === prevData.delivery_location
      );
    else selectedLocation = savedUserLocations[0];

    if (geoLocation) {
      selectedLocation = getMinDistanceLocation(savedUserLocations, geoLocation);
    }
    deliveryLocation = selectedLocation
      ? `${selectedLocation.latitude},${selectedLocation.longitude}`
      : `0,0`;
  }

  let order_type = location.orderTypes.length > 0 && prevData !== undefined ? prevData.order_type_id ? location.orderTypes.filter((ot) => ot.id === prevData.order_type_id) : location.orderTypes : location.orderTypes;
  if (allowedOrderTypes[order_type.length > 0 ? order_type[0].order_type : 'delivery']) {
    selectedOrderType = order_type[0];
    const pickedOutlets = OrderTypeHelper.pickOutletsFor(
      location.orderTypes,
      selectedOrderType.id,
      outlets
    );
    selectedOutlet = defaultOutlet ? defaultOutlet : pickedOutlets[0];
    if (deliveryLocation && selectedOutlet.loc_id !== location.loc_id) {
      let minDistance = 99999;
      for (let i = 0; i < pickedOutlets.length; i++) {
        const dis = GoogleHelper.distanceBetweenTwoLatLngStrings(
          deliveryLocation,
          `${pickedOutlets[i].latitude},${pickedOutlets[i].longitude}`
        );
        if (dis <= minDistance) {
          selectedOutlet = pickedOutlets[i];
          minDistance = dis;
        }
      }
    }
  } else {
    const orderTypes = OrderTypeHelper.sortOrderTypes(location.orderTypes).filter(
      (ot) => allowedOrderTypes[ot.order_type]
    );
    selectedOrderType = orderTypes[0];
    const pickedOutlets = OrderTypeHelper.pickOutletsFor(
      location.orderTypes,
      selectedOrderType.id,
      outlets
    );
    selectedOutlet = defaultOutlet ? defaultOutlet : pickedOutlets[0];
    if (deliveryLocation && selectedOutlet.loc_id !== location.loc_id) {
      let minDistance = 99999;
      for (let i = 0; i < pickedOutlets.length; i++) {
        const dis = GoogleHelper.distanceBetweenTwoLatLngStrings(
          deliveryLocation,
          `${pickedOutlets[i].latitude},${pickedOutlets[i].longitude}`
        );
        if (dis <= minDistance) {
          selectedOutlet = pickedOutlets[i];
          minDistance = dis;
        }
      }
    }
  }
  const current_time = Date.now();
  if (prevData) {
    return {
      ...prevData,
      current_time,
      delivery_location: deliveryLocation,
      delivery_address: selectedLocation ? selectedLocation.address : '',
      order_type_id: selectedOrderType.id,
      order_time: current_time,
      order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
      isPickUpNow: 1,
      selectedOutlet,
      isTakeAwayAvail: false,
      selectedLocation,
      editLocation: '',
      itemIndex: '',
      showAlerModal: false,
      savedLocations: [],
      deliveryOutletError: false
    };
  }

  return {
    errors: [],
    showErrors: false,
    showMapModal: false,
    showTimePickerModal: false,
    showOutlets: false,
    showSavedLocations: false,
    current_time,
    delivery_phone: '',
    delivery_location: deliveryLocation,
    delivery_address: selectedLocation ? selectedLocation.address : '',
    car_number: '',
    car_model: '',
    comment: '',
    order_type_id: selectedOrderType.id,
    order_time: current_time,
    order_date: CONSTANTS.ORDERS.VARIABLES.TIME_OPTIONS.TODAY,
    isPickUpNow: 1,
    selectedOutlet,
    isTakeAwayAvail: false,
    selectedLocation,
    editLocation: '',
    itemIndex: '',
    showAlerModal: false,
    savedLocations: [],
    deliveryOutletError: false
  };
}

function getOrderData(orderTypes, location) {
  const loc_id = location?.is_outlet ? location?.parent_id : location?.loc_id;
  let orderData = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${loc_id}_orderData`);
  if (orderData) {
    orderData = JSON.parse(orderData);
    let time = new Date(orderData['order_time']);
    orderData['order_time'] = time;
    // Getting order_type_id back from order types of current location
    let orderType = orderTypes.find((ot) => ot.order_type === orderData.order_type);
    if (orderType) orderData.order_type_id = parseInt(orderType.id);
    //delete orderData['order_type'];
    return orderData;
  }
}

function clearOrderData(location) {
  const loc_id = location.is_outlet ? location.parent_id : location.loc_id;
  let orderData = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${loc_id}_orderData`);
  if (orderData) {
    orderData = JSON.parse(orderData);
    delete orderData['order_type'];
    delete orderData['order_type_id'];
    localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_${loc_id}_orderData`, JSON.stringify(orderData));
  }
}
